import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgFor, NgIf} from '@angular/common';

export interface SegmentedControlOption {
  label: string;
  value: string | number;
  description?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-segmented-control',
  standalone: true,
  imports: [
    NgClass,
    NgFor,
    NgIf,
  ],
  templateUrl: './segmented-control.component.html',
  styleUrl: './segmented-control.component.scss'
})
export class SegmentedControlComponent {
  @Input() options: SegmentedControlOption[] = [];
  @Input() value: string | number | null = null;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string | number>();

  public selectOption(option: SegmentedControlOption): void {
    if (this.disabled || option.disabled || option.value === this.value) {
      return;
    }

    this.valueChange.emit(option.value);
  }

  public trackByValue(_: number, option: SegmentedControlOption): string | number {
    return option.value;
  }
}
